// The text of a mission refused because its company is a prospect or a lost
// one (409 COMPANY_NOT_CLIENT, on creation and duplication), or null when the
// refusal is about something else.
export const getMissionCompanyErrorMessage = (language, err) =>
  err?.response?.data?.errorCode === 'COMPANY_NOT_CLIENT'
    ? language.getValue('createMission.errors.companyNotClient', '')
    : null;
